import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingBmpToJpegConfig } from '@/data/landingConfig/landingBmpToJpegConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_BmpToJpeg } from './schemaObject';

interface Props {}
const BmpToJpegConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_BmpToJpeg} />
			<LandingTemplate
				data={landingBmpToJpegConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default BmpToJpegConverter;
